export default "__VITE_ASSET__q$$l8R7c__"